<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="multisteps-form mb-9">
          <div class="row">
            <div class="col-12 col-lg-8 mx-auto my-5"></div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-8 m-auto">
              <div class="card">
                <div
                  class="card-header p-0 position-relative mt-n4 mx-3 z-index-2"
                >
                  <div
                    class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3"
                  >
                    <div class="multisteps-form__progress">
                      <button
                        class="multisteps-form__progress-btn"
                        type="button"
                        title="Editar Permiso"
                        :class="activeStep >= 0 ? activeClass : ''"
                      >
                        <span>Editar Perfil de Impresión</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <form class="multisteps-form__form">
                    <!--single form panel-->
                    <h5 class="font-weight-bolder mb-0">Información de Permiso de Impresión</h5>
                    <div class="multisteps-form__content">
                      <div class="row mt-5">
                        <div class="col-12 col-sm-6">
                          <label class="form-label col-sm-12">
                            <input
                                id="name"
                                v-model="item.name"
                                placeholder=" "
                                type="text"
                                class="form-control border-bottom"
                                name="name"
                                required
                            />
                            <span>Nombre *</span>
                          </label>
                        </div>
                        <div class="col-12 col-sm-6">
                          <label class="form-label col-sm-12">
                            <input
                                id="labelSize"
                                v-model="item.labelSize"
                                placeholder=" "
                                type="text"
                                class="form-control border-bottom"
                                name="labelSize"
                                required
                            />
                            <span>Tamaño Etiqueta *</span>
                          </label>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-12 col-sm-6">
                          <label class="form-label col-sm-12">
                            <input
                                id="leafMargins"
                                v-model="item.leafMargins"
                                placeholder=" "
                                type="text"
                                class="form-control border-bottom"
                                name="leafMargins"
                                required
                            />
                            <span>Márgenes de la Hoja *</span>
                          </label>
                        </div>
                        <div class="col-12 col-sm-6">
                          <label class="form-label col-sm-12">
                            <input
                                id="separationBetweenLabels"
                                v-model="item.separationBetweenLabels"
                                placeholder=" Example 1,2 "
                                type="number"
                                class="form-control border-bottom"
                                name="separationBetweenLabels"
                                required
                            />
                            <span>Separación entre etiquetas  *</span>
                          </label>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-12 col-sm-6">
                          <label class="form-label col-sm-12">
                            <select
                                id="sheetPosition"
                                class="form-control border-bottom"
                                v-model="item.sheetPosition"
                                name="sheetPosition"
                            >
                              <option v-for="(sp, index) in sheetPosition" :key="index" :value="sp">{{ sp }}</option>
                            </select>
                            <span>Posición de la Hoja *</span>
                          </label>
                        </div>
                        <div class="col-12 col-sm-6">
                          <label class="form-label col-sm-12">
                          <input
                              id="sheetSize"
                              v-model="item.sheetSize"
                              name="sheetSize"
                              placeholder=" Example Carta, Oficio, RollXX "
                              type="number"
                              class="form-control border-bottom"
                              required
                          />
                            <span>Tamaño de la Hoja *</span>
                          </label>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-12 col-sm-8">
                          <label class="form-label col-sm-12">
                            <select
                                id="user"
                                v-model="item.user"
                                class="form-control border-bottom custom-select"
                                name="user"
                                required
                            >
                              <option v-for="(user, index) in users" :key="index" :value="user.id">{{ user.username }}</option>
                            </select>
                            <span>Usuario *</span>
                          </label>
                        </div>
                      </div>
                      <div v-if="error !== ''">
                        <label
                            type="error"
                            :value="alert"
                            class="alert-warning text-bold"
                        >
                          {{ error }}
                        </label>
                      </div>
                      <div class="row" v-if="ok != null">
                        <material-alert
                            border="top"
                            close-icon="$cancel"
                            :color="colorAlert()"
                            transition="scale-transition"
                            :value="ok"
                            dismissible
                        >
                          {{ textAlert() }}
                        </material-alert>
                      </div>

                      <div class="button-row d-flex mt-4">
                        <material-button
                            type="button"
                            color="danger"
                            variant="danger"
                            class="js-btn-send"
                            @click="getRoutePrintingProfileList()"
                        >Cancelar</material-button
                        >
                        <material-button
                            type="button"
                            color="dark"
                            variant="gradient"
                            class="ms-auto js-btn-send"
                            @click="editPrintingProfile()"
                        >Aceptar</material-button
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialAlert from "@/components/MaterialAlert.vue";


export default {
  name: "EditPrintingProfile",
  components: {
    MaterialAlert,
    MaterialButton,
  },
  data() {
    return {
      showMenu: false,
      showChangePass: false,
      changePassword: null,
      activeClass: "js-active position-relative",
      activeStep: 0,
      formSteps: 3,
      error: '',
      ok: null,
      alert: false,
      idItem: -1,
      users: [],
      sheetPosition: {
        VERICAL: 'VERTICAL',
        HORIZONTAL: 'HORIZONTAL'
      },
      sheetSizes: {
        A4: 'A4',
        CARTA: 'CARTA',
        OFICIO: 'OFICIO'
      },
      item: {
        name: '',
        labelSize: '',
        leafMargins: '',
        separationBetweenLabels: '',
        sheetPosition: '',
        sheetSize: '',
        user: null,
      }
    };
  },
  computed: {
    getPerm() {
      if (this.idItem > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.item = this.$store.getters.getPermission
        return this.item;
      }
      return null
    },
  },
  watch :{
    "$store.state.printingProfile": function(printingProfile) {
      this.item = printingProfile;
      console.log("Permission: ", this.item)
    },
    '$store.state.ok': function (value) {
      console.log("state.ok: ", value)
      if (value){
        this.ok = true;
        setTimeout(this.getRoutePrintingProfileList, 100);
      }
    },
    '$store.state.errorMessage': function (message) {
      this.error = message;
      this.alert = true;
    },
    '$store.state.usersList': function (users) {
      this.users = users;
    },
  },
  methods: {
    textAlert() {
      return this.ok
          ? "Perfil de Impresión modificado satisfactoriamiente"
          : "Error al intentar modificar el Perfil de Impresión";
    },
    colorAlert() {
      return this.ok ? "success" : "danger";
    },
    getRoutePrintingProfileList(){
      this.$router.push({ path: "/printingProfile/list" });
    },
    editPrintingProfile() {
      this.$store.dispatch('actionsEditPrintingProfile', {
        axios: this.$axios,
        id: this.item.id,
        name: this.item.name,
        sheetSize: this.item.sheetSize,
        labelSize: this.item.labelSize,
        leafMargins: this.item.leafMargins,
        sheetPosition: this.item.sheetPosition,
        separationBetweenLabels: this.item.separationBetweenLabels,
        user: this.item.user,
      });
    },
  },
  async created() {
    this.$store.dispatch('actionsGetAllUsers', {'axios': this.$axios});
    this.users = await this.$store.getters.getAllUsers;
    this.idItem = this.$route.params.id !== undefined ? this.$route.params.id : -1;
    this.$store.dispatch('actionsGetPrintingProfile', {
      'axios': this.$axios,
      'id': this.idItem
    })
  }
};
</script>
<style>
.form-label {
  position: relative;
  display: inline-block;
}


.form-label span {
  position: absolute;
  left: 5px;
  top: 0;
  transition: 0.2s;
  pointer-events: none;
}

.form-label input:focus + span,
.form-label input:not(:placeholder-shown) + span {
  transform: translateY(-20px);
  font-size: 0.8em;
}
.custom-select {
  appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5"><path fill="%23aaa" d="M2 0L0 2h4zm0 5L0 3h4z"/></svg>');
  background-repeat: no-repeat;
  background-position: right .75rem center;
  background-size: 8px 10px;
}
.form-label select:focus + span,
.form-label select:not(:placeholder-shown) + span {
  transform: translateY(-15px);
  font-size: 0.8em;
}
</style>
